import {MobileSiteMenu} from "./site-menu";
import lozad from 'lozad';
import imagesLoaded from 'imagesloaded';

function isMobile() {
    return (/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera);
}
function IsSafari() {
    return /^((?!chrome).)*safari/i.test(navigator.userAgent);
}

function getCurrentScroll() {
	return window.pageYOffset || document.documentElement.scrollTop;
}
var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame;
var $window = $(window);
var lastScrollTop = $window.scrollTop();
var shrinkHeader = 25;
var delayedScroll = 0;
var elObj = $('#mainmenu');
if (raf) {
	loop();
}
function loop() {
	var scrollTop = $window.scrollTop();
	if (lastScrollTop === scrollTop) {
		raf(loop);
		return;
	} else {
		lastScrollTop = scrollTop;
		scroll();
		raf(loop);
	}
}
var scroll = function () {
	var scrolled = getCurrentScroll();
	if ( scrolled > delayedScroll && scrolled >80) {
		elObj.addClass('scrolled');
		if(scrolled>=shrinkHeader) {
			elObj.addClass('fullcolor');
		}
	} else {
		elObj.removeClass('scrolled');
		if(scrolled<=shrinkHeader) {
			elObj.removeClass('fullcolor');
		}
	}
	delayedScroll = scrolled;
};

// lock window scrolling
function lockScroll(e) {
    e.preventDefault();
}

function detailImageGoFull() {
    $('html, body').animate({
        scrollTop: 0
    }, 500);

    $('.prodDetailBox .related').addClass('op-0');
    $('.prodDetailBox .relatedCont').addClass('op-0');
    setTimeout(function () {
        $('.prodDetailBox .text').addClass('away');
    },550);

    $('#close-fullImage').addClass('st-1');

    setTimeout(function () {
        $('#mainmenu').addClass('awayUp');
        $('.prevnext').addClass('awayUp');
	    $('.info_int').addClass('d-none');
        $('.prodDetailBox .text').addClass('step-2');
        $('.prodDetailBox .image').addClass('fullWidth');
        $('.big-image').addClass('pullUp');
    },600);

    setTimeout(function () {
        $('#close-fullImage').addClass('st-2');
    },800);

    // disable scrolling
    $('html,body').bind('mousewheel touchmove', lockScroll);

}

function detailImageTurnBack() {
    $('#mainmenu').removeClass('awayUp');
    $('.prevnext').removeClass('awayUp');
	$('.info_int').removeClass('d-none');
    $('.prodDetailBox .text').removeClass('step-2');
    $('.prodDetailBox .image').removeClass('fullWidth');
    $('.big-image').removeClass('pullUp');
    $('#close-fullImage').removeClass('st-2');

    setTimeout(function () {
        $('.prodDetailBox .text').removeClass('away');
        $('#close-fullImage').removeClass('st-1');
        $('html, body').animate({
            scrollTop: $('html, body').scrollTop()
        }, 500);
    },600);
	setTimeout(function () {
	    $('.prodDetailBox .related').removeClass('op-0');
	    $('.prodDetailBox .relatedCont').removeClass('op-0');
	},800);

	// enable scrolling
    $('html,body').unbind('mousewheel touchmove', lockScroll);
}

jQuery(function ($) {

	$('#filtri .a-filters-category ').click(function () {
		if ($(this).siblings('.sott_filCat').length > 0) {
			if ($(this).hasClass('opened')) {
				$(this).siblings('.sott_filCat').fadeOut();
				$(this).removeClass('opened');
			} else {
				$(this).closest('ul').find('.sott_filCat').fadeOut();
				$(this).closest('ul').find('.opened').removeClass('opened');
				$(this).siblings('.sott_filCat').fadeIn();
				$(this).addClass('opened');
			}
		}

	})

    $('#menu-maintenance23 .menu-maintenance-23-a').click(function () {
		if ($(this).siblings('.sott_maintenance').length > 0) {
			if ($(this).hasClass('opened')) {
				$(this).siblings('.sott_maintenance').fadeOut();
				$(this).removeClass('opened');
			} else {
				$(this).closest('ul').find('.sott_maintenance').fadeOut();
				$(this).closest('ul').find('.opened').removeClass('opened');
				$(this).siblings('.sott_maintenance').fadeIn();
				$(this).addClass('opened');
			}
		}

	})



	if ($('.pgCategoria__relatedCarousel').length > 0) {
		var highlightCarousel = $('.pgCategoria__relatedCarousel').slick({
			arrows: false,
			dots: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 1,
					}
				}
			]
		});
	}



	if (window.matchMedia("screen and (max-width: 992px)").matches) {
		$('.has-submenu').on({
			'click': function (e) {
			},
			'mouseleave': function () {
				if($(".has-submenu:hover").length == 0) {
					$('.rollSubmenu').removeClass('on');
					if (!$('body').hasClass('page_internati')) {
						$('.menuRoll').removeClass('internati');
					}
					$('.rollSubmenu__wrap').removeClass('on');
					$('.rollSubmenu__bg').removeClass('on');
					$('.rollSubmenu').removeClass('on');
					$('.has-submenu').removeClass('active');
				}
			}
		});
	} else {

		$('.has-submenu').on({
			'mouseenter': function () {
				$('.has-submenu').removeClass('active');
				$(this).addClass('active');
				var targ = $(this).data('target');

				$('.rollSubmenu__ct').removeClass('on');
				$('.rollSubmenu__wrap').removeClass('on');
				$(targ).addClass('on');

				setTimeout(function () {
					$('.menuRoll').addClass('internati');
					$('.rollSubmenu__bg').addClass('on');
				},10);
				setTimeout(function () {
					$(targ).find('.rollSubmenu__wrap').addClass('on');
				},10);
			},
			'mouseleave': function () {
				if($(".has-submenu:hover").length == 0) {
					$('.rollSubmenu').removeClass('on');
					if (!$('body').hasClass('page_internati')) {
						$('.menuRoll').removeClass('internati');
					}
					$('.rollSubmenu__wrap').removeClass('on');
					$('.rollSubmenu__bg').removeClass('on');
					$('.rollSubmenu').removeClass('on');
					$('.has-submenu').removeClass('active');
				}
			}
		});

	}


	$('.rollSubmenu__back').click(function () {

		$('.rollSubmenu__wrap').removeClass('on');

		setTimeout(function () {
			$('.rollSubmenu__ct').removeClass('on');
			$('.rollSubmenu__bg').removeClass('on');
			$('.has-submenu').removeClass('active');
		},500);
	});

	$('.rollSubmenu').on({
		'mouseenter': function () {

			var targ = $('.rollSubmenu__ct.on');
			var par = '#' + $(targ).attr('id') + '-lnk';


			$(targ).addClass('on');
			$('.menuRoll').addClass('internati');

			setTimeout(function () {
				$('.rollSubmenu__bg').addClass('on');
				$(par).addClass('active');
				$(targ).find('.rollSubmenu__wrap').addClass('on');
			},10);

		},
		'mouseleave': function () {


			if($(".has-submenu:hover").length == 0) {

				setTimeout(function () {

					$('.rollSubmenu__wrap').removeClass('on');


				},50);

				setTimeout(function () {

						if (!$('body').hasClass('page_internati')) {
							$('.menuRoll').removeClass('internati');
						}

						$('.rollSubmenu__ct').removeClass('on');
						$('.rollSubmenu__bg').removeClass('on');
						$('.has-submenu').removeClass('active');

				},100);

			}
		}
	});


	//end2021


	//slideshow autoplay
    let slideshowAuto = setInterval(function () {
        jQuery('.boxnav__item--next').click();
    },50000);

    $('.boxnav').hover(function () {
		clearInterval(slideshowAuto);
    },function () {
        slideshowAuto = setInterval(function () {
            jQuery('.boxnav__item--next').click();
        },50000);
    });

	//cerca
	$('.icn_cerca').click(function () {
		$('.search-ct').addClass('st1');

		setTimeout(function () {
            $('.search-ct').addClass('st2');
            $('.search-ct').addClass('on');
            $('.ui-searchinput').focus()
        },50);
    });
	$('.search-close').find('.icon--close').click(function () {
        $('.search-ct').removeClass('st2');
        $('.search-ct').removeClass('on');
        setTimeout(function () {
            $('.search-ct').removeClass('st1');
        },500);
    });

	//cart usa
	$('body').on('click', '.carrellousa .mycart_usa', function () {
		$('.cart_usa').addClass('open');
	});
	$('body').on('click', '.carrellousa .cart_usa .close_usa',  function () {
		$('.cart_usa').removeClass('open');
	});

	// CART
	$('body').on('click', '.minicart .mycart', function() {
		$('.cart').addClass('open');
	});
	$('body').on('click', '.minicart .cart .close_cart', function() {
		$('.cart').removeClass('open');
	});

	//img zoom dett
	$('#close-fullImage').click(function () {
        detailImageTurnBack();
    });
    $('.big-image').click(function () {
        detailImageGoFull();
    });

	$('[data-toggle="tooltip"]').tooltip();

	// DEALERS
	$('.click_change').on('click', function(){
		$('#dealerListH').addClass('open');
		setTimeout(function () {
			$('#dealerListH').addClass('on1');
			$('#dealerListH').addClass('on2');
		},50);
	});
	$('#dealerListH #close').on('click', function(){
		$('#dealerListH').removeClass('on1');
		$('#dealerListH').removeClass('on2');
		setTimeout(function () {
			$('#dealerListH').removeClass('open');
		},500);
	});

	//popup
	setTimeout(function () {
		$('.popup_nl').hide();
	}, 6000);

	$('.closepop').on('click', function () {
		$('.popup_nl').hide();
        var date = new Date();
        document.cookie = "pop_nl_visto=1; expires=" + date.setTime(date.getTime() + (15*24*60*60*1000)) + "; path=/";
	});

	// ICE SCKATE
	$('.icebtn').on('click', function() {
		$('.mn_ice').toggleClass('open');
		$('.drop_ice').slideToggle('600');
	});

	//+-
	$('.cascata .wrap_accordion .panel .acc_heading').on('click', function(){
		$(this).find('.plus').toggleClass('minus');
	});
	$('.cascata .wrap_accordion_l2 .panel .acc_heading_l2').on('click', function(){
		$(this).find('.plus').toggleClass('minus');
	});

	// ancore gui&main
	$('#anc_dom a').on('click',function () {
		trg = $(this).attr('href');
		postop = $(trg).offset().top - 150;
		$("html,body").animate({scrollTop:postop},1500);
		$(trg+' a.acc_heading').click();
		return false;
	});

	$('.col-filtri .dropdown').on('hide.bs.dropdown',function(r){
		text = $('.sel',this).text();
		$('button',this).text(text);
	});
	// OPEN FILTRI MOBILE
	$('.filtri_mob .open_filtri').on('click', function () {
		$('.filtri_mob').addClass('openf');
		$('.fil_sx').removeClass('col-6').addClass('col-12');
	});
	$('.filtri_mob .closef').on('click', function () {
		$('.filtri_mob').removeClass('openf');
		$('.fil_sx').removeClass('col-12').addClass('col-6');
	});

	$('.special-offers__checkbox').click(function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).find('.span-checked').css('opacity',0);
			$(this).find('input[type=checkbox]').trigger('click');
		} else {
			$(this).addClass('active');
			$(this).find('.span-checked').css('opacity',1);
			$(this).find('input[type=checkbox]').trigger('click');
		}
	});


	//netflix
	var owl = $(".owl_tech").slick({
		arrows: false,
		dots: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					slidesToScroll:1,
					slidesToShow:1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToScroll:2,
					slidesToShow:2
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToScroll:3,
					slidesToShow:3
				}
			},
		]
	});

    $(".banslide_info").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 4000,
        arrows: window.matchMedia('(min-width: 768px)').matches ?  true :  false,
        dots: window.matchMedia('(min-width: 768px)').matches ? false : true,
    });

    $(".slide_detmod.owl-carousel").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
    });

    $(".slide-info.owl-carousel").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: true,
        dots: false,
    });

    $(".owl_atl").slick({
        arrows: true,
        dots: false,
        slidesToShow: 4.5,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToScroll:1,
                    slidesToShow:1,
                    arrows: false,
                    dots: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll:2,
                    slidesToShow:2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToScroll:3,
                    slidesToShow:3
                }
            },
        ]
    });

    $(".webtv_list").slick({
        arrows: false,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToScroll:1,
                    slidesToShow:1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll:2,
                    slidesToShow:2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToScroll:3,
                    slidesToShow:3
                }
            },
        ]
    });

    $(".latestNews").slick({
        arrows: false,
        dots: true,
        slidesToShow: 2.1,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToScroll:1.1,
                    slidesToShow:1
                }
            },
        ]
    });


    $(".rel_slide").slick({
        arrows: false,
        dots: true,
        slidesToShow: 5 ,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToScroll:1,
                    slidesToShow:1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll:2,
                    slidesToShow:2
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToScroll:3,
                    slidesToShow:3
                }
            },
        ]
    });

    // slider mobile filtri Latest news
    $(".news_filters").slick({
        slidesToShow : 2.5,
        slidesToScroll : 1,
        mobileFirst : true,
        arrows : false,
        infinite: false,
        responsive : [{
            breakpoint : 992,
            settings: 'unslick'
        }, {
            breakpoint : 768,
            settings: {
                slidesToShow : 4.5,
                slideToScroll: 1
            }
        }, {
            breakpoint : 468,
            settings: {
                slidesToShow : 2.5,
                slideToScroll: 1
            }
        }]
    });

    // slider mobile filtri Lista prodotti
    $(".category-filters25-wrapper").slick({
        slidesToShow : 2.5,
        slidesToScroll : 1,
        mobileFirst : true,
        arrows : false,
        infinite: false,
        responsive : [{
            breakpoint : 768,
            settings: 'unslick'
        }, {
            breakpoint : 468,
            settings: {
                slidesToShow : 2.5,
                slideToScroll: 1
            }
        }]
    });



	// menu mob experience
	$('.expMenu .open_exp').on('click', function(){
		$('ul').slideToggle('800').toggleClass('open');
	});

    if(!isMobile()) {

        /*$(".catFilter a, .dropFilter a").click(function(){
            $('html, body').animate({scrollTop:0}, 1000,'easeInOutQuad');
            //return false;
        });*/
    }

	$('.ststs_pg').delegate( ".login_ststs", "click", function() {
		$('#goto').val($(this).data("target"));
		$.fancybox.open({
			src  : '#lockpage',
			type : 'inline'
		});
	});


    $('#ecomm-form').on('submit', function () {
	   window.location.reload();
    });

	$('.ststs_pg:contains("®")').html(function () {
		return this.innerHTML.replace("®", "<span style='font-size:14px; vertical-align:super; font-family:Roboto,Arial,sans-serif;'>®</span>");
	});
	$('.ststs_pg p:contains("®")').html(function () {
		return this.innerHTML.replace("®", "<span style='font-size:12px; vertical-align:super; font-family:Roboto,Arial,sans-serif;'>®</span>");
	});
	$('.ststs_pg p strong:contains("®")').html(function () {
		return this.innerHTML.replace("®", "<span style='font-size:13px; vertical-align:super; font-family:Roboto,Arial,sans-serif;'>®</span>");
	});


    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }


    $( document ).ready(function() {
        let banner = document.getElementById("main-banner");
        const closeBanner = () =>{
            setCookie("popupNewsletter", "closed", 1);
            banner.style.display = 'none';
        }

        $('.main-banner_white-close').click(function() {
            closeBanner();
        })
        $('.main-banner_dark-close').click(function() {
            closeBanner();
        })

        $('.main-banner_btn-cta').click(function() {
            closeBanner();
        })

        // document.addEventListener('click', (event) => {
        //     if (!document.getElementById('banner-box').contains(event.target)) {
        //         closeBanner();
        //     }
        // });

        if (getCookie("popupNewsletter") !== "closed" && banner !== null) {
            window.addEventListener('scroll', function () {
                if (getCookie("popupNewsletter") !== "closed") {
                    banner.style.display = 'block';
                }
            });
        }
    });

    function sendTrackingMenu(lv1,lv2,lv3,e, isBanner = '') {
        isBanner = isBanner === 'banner';
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'click_menu',
            'lv1': lv1,
            'lv2': lv2,
            'lv3': lv3,
            'is_banner' : isBanner
        });
        // window.location = e.target.href;
        let anchor = document.createElement('a');
        anchor.href = e.currentTarget.href;
        anchor.target= e.currentTarget.target;
        anchor.click();
        // window.location = e.target.href;
    }

    $('.menu-lv-3').on('click', function(e) {
        e.preventDefault()
        var lv3 = ($(this).data('value-lv3')).toLowerCase().replace(/ /g, '_')
        var lv2 =  ($(this).data('value-lv2')).toLowerCase().replace(/ /g, '_')
        var lv1 =  ($(this).data('value-lv1')).toLowerCase().replace(/ /g, '_')
        sendTrackingMenu(lv1,lv2,lv3, e)

    });
    $('.menu-lv-2').on('click', function(e) {
        e.preventDefault()
        var lv2 =  ($(this).data('value-lv2')).toLowerCase().replace(/ /g, '_')
        var lv1 =  ($(this).data('value-lv1')).toLowerCase().replace(/ /g, '_')
        var isBanner =  ($(this).data('value-is_banner')).toLowerCase().replace(/ /g, '_')
        sendTrackingMenu(lv1,lv2,'',e, isBanner)
    });
    $('.menu-lv-1').on('click', function(e) {
        e.preventDefault()
        var lv1 = ($(this).data('value-lv1')).toLowerCase().replace(/ /g, '_')
        sendTrackingMenu(lv1,'','',e)
    });

    function sendTrackingUpselling(category,productName,e) {
        console.log(category,productName);
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'upselling',
            'category': category,
            'productName': productName,
        });

        window.location = e.target.href;

    }

    $('body').on('click', '.link-trending', function(e) {
        e.preventDefault()
        let productName = $(this).data('product-name')
        sendTrackingUpselling('trending', productName, e);
    })

    $('body').on('click', '.link-best_selling', function(e) {
        e.preventDefault()
        let productName = $(this).data('product-name')
        sendTrackingUpselling('best_selling', productName, e);
    })

    $('body').on('click', '.link-new', function(e) {
        e.preventDefault()
        let productName = $(this).data('product-name')
        sendTrackingUpselling('new', productName, e);
    })


    updateToken();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let selectCountryTab = urlParams.get('select-country')
    if(selectCountryTab === 'true') {
        $('#dealerListH').addClass('open on1 on2')
    }

    window.addEventListener('livewire-filter-products', function(event) {
        var filters = event.detail.filters
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'click_filters',
            'filters': filters
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    })

    window.addEventListener('reload-carousel', function(event) {
        $(".rel_slide").slick({
            arrows: false,
            dots: true,
            slidesToShow: 5 ,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToScroll:1,
                        slidesToShow:1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToScroll:2,
                        slidesToShow:2
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToScroll:3,
                        slidesToShow:3
                    }
                },
            ]
        });
    });
});

function updateToken() {
    jQuery.ajax({
        type: 'GET',
        url: window.token + "?time=" + (Date.now() / 1000 | 0),
        data: {},
        success(result) {
            jQuery.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': result
                }
            });

            jQuery('meta[name="csrf-token"]').attr('content', result);

            if (jQuery('input[name=_token]').length) {
                jQuery('input[name=_token]').val(result);
            }

            setTimeout(updateToken, 1000 * 60);
            const event = new CustomEvent('tokenUpdated');
            window.dispatchEvent(event);
        },
        error() {}
    });
}



/**
 * Site menu
 */
const mainHeader = document.querySelector('#mainmenu');
const mobileOffcanvas = mainHeader.querySelector('#offcanvas-mobile');
if (mobileOffcanvas) {
    new MobileSiteMenu(mobileOffcanvas);
}

/**
 * Product list input price range
 * @type {Element}
 */
const rangeMin = document.querySelector('#range_min');
const rangeMax = document.querySelector('#range_max');
const rangeTrack = document.querySelector('#range_track');
const minValueSpan = document.querySelector('#min_value span');
const maxValueSpan = document.querySelector('#max_value span');
if (rangeMin && rangeMax && rangeTrack && minValueSpan && maxValueSpan) {
    const getPercentage = (rangeValue) => {
        return (rangeValue.value / 999 * 100);
    }
    rangeMin.addEventListener('input', () => {
        const left = getPercentage(rangeMin);
        const width = getPercentage(rangeMax);
        rangeTrack.style.left = `${left}%`;
        rangeTrack.style.width = `${width - left}%`;
        minValueSpan.textContent = rangeMin.value;
    });
    rangeMax.addEventListener('input', () => {
        const left = getPercentage(rangeMin);
        const width = getPercentage(rangeMax);
        rangeTrack.style.right = `${width}%`;
        rangeTrack.style.width = `${width - left}%`;
        maxValueSpan.textContent = rangeMax.value;
    });
}

function reloadHomeCarouselSlick() {
    var params_slick = {
        arrows: false,
        dots: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1.5
                }
            }
        ]
    };
    $('.trending-carousel').slick(params_slick);
}
window.addEventListener('livewire-home-carousel', function(event) {
    reloadHomeCarouselSlick()
});

if( $('.trending-carousel')) {
    reloadHomeCarouselSlick()
}

function setSrcFromDataSrc(items) {
    if (!items || items.length === 0) {
        return
    }
    items.forEach(item => {
        if (!item.hasAttribute('src') && item.hasAttribute('data-src')) {
            item.setAttribute('src', item.dataset.src);
            item.parentNode.classList.add('media-loaded');
        }
        if (!item.hasAttribute('srcset') && item.hasAttribute('data-srcset')) {
            item.setAttribute('srcset', item.dataset.srcset);
        }
    })
}

/**
 * Lazy load
 */
const lazyItems = document.querySelectorAll('.lazy');
if (lazyItems.length) {
    const classToCheck = ['highlightProducts__slide-thumb', 'boximg', 'articles-image-block','boxcol','mte__box']
    let options = {
        loaded: function (el) {
            imagesLoaded(el, function () {
                if (el.parentNode && classToCheck.some(cls => el.parentNode.classList.contains(cls))) {
                    el.parentNode.classList.add('media-loaded');
                }
            });
            if (!el.alt && el.dataset.alt) {
                el.alt = el.dataset.alt;
            }
        },
    };

    const observer = lozad(lazyItems, options);
    observer.observe();
}

/**
 * livewire render after changes in product list page
 * @type {NodeListOf<Element>}
 */
window.addEventListener('livewire-reload-lazy-images', (e) => {
    const productImages = document.querySelectorAll('.imgprd');
    if (productImages.length) {
        setSrcFromDataSrc(productImages);
    }
    const homeCarouselImages =  document.querySelectorAll('.highlightProducts__slide-thumb img');
    if(homeCarouselImages.length) {
        setSrcFromDataSrc(homeCarouselImages);
    }
    const articlesImages =  document.querySelectorAll('.articles-image-block img');
    if(articlesImages.length) {
        setSrcFromDataSrc(articlesImages);
    }

});



